import { useUserStore } from "@/stores/useUserStore.ts";
import { authenticatedFetch, getFlowUri, QueryFromVars } from "@/api/shared.ts";

const JsonHeaders = { "Content-Type": "application/json" };

// TODO: If we ever end up using lesson-hub/dispatch for more things, make it more generic
export const postRequestHelp = async () => {
  const { userDetails } = useUserStore.getState();
  const response = await authenticatedFetch(getFlowUri(`/v1/signalr-hubs/lesson-hub/dispatch`), {
    method: "POST",
    headers: JsonHeaders,
    body: JSON.stringify({
      groups: ["LessonDashboardGroup"],
      methods: ["RedAlert"],
      payload: JSON.stringify({
        userName: userDetails?.userName,
        dateCreated: new Date().toISOString(),
      }),
    }),
  });

  if (!response.ok) {
    throw new Error(`Request failed with status ${response.status}`);
  }

  return response;
};

export const postSlackMessage = async (message: string, channelId?: string) => {
  const query = QueryFromVars([{ name: "message", value: message }]);
  const id = channelId ?? "C0260NMLV8X";

  const response = await authenticatedFetch(getFlowUri(`/slack/channels/${id}${query}`), {
    method: "POST",
    headers: JsonHeaders,
  });

  if (!response.ok) {
    throw new Error(`Request failed with status ${response.status}`);
  }

  return response;
};
